import fetchApi from "../fetchApi";

export const GetRole = async (id) => {
  const options = {
    method: "GET",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    redirect: "follow",
  };

  return await fetchApi(`roles/${id}`, options);
};
